import { LabMDM } from "./lab";
import { SalesItemType } from "./salesItemType";

export class SalesItemTypeConfig extends SalesItemType {

    /** The lab . */
    lab: LabMDM;

    /** The sales item type. */
    bmsKitProductName: string;

    /** The sales item type. */
    bmsTubeProductName: string;

    /** The sales item type. */
    jobTime: string;

    /** The max redo*/
    maxRedo: number;

}